// removed by extract-text-webpack-plugin
module.exports = {"ScreenXXSMin":"(min-width: 544px)","modalContent":"G4732ce G3a5ce6","disableScroll":"Gce5794","bold":"G751573 G13d4db"};